<template>
  <AppSelect
    v-if="branches.length"
    :model-value="branch.locale"
    :items="branches"
    hide-details plain eager rounded
  >
    <template #item="{ item }">
      <a :href="buildUrl(getDomainByBranch(item.value), $route.fullPath)" class="plain">
        <CountryFlag :code="getBranchByCode(item.value).baseCountry" start />
        <span class="lang">{{ LANGS[getBranchByCode(item.value).language] }}</span>
        <span class="country">{{ shortenCountry(getBranchByCode(item.value).baseCountry) }}</span>
      </a>
    </template>

    <template #selection>
      <CountryFlag :code="branch.baseCountry" start />
      <span class="lang">{{ LANGS[branch.language] }}</span>
      <span class="country">{{ shortenCountry(branch.baseCountry) }}</span>
    </template>
  </AppSelect>
</template>

<script setup lang="ts">
import { getBranchByCode, getAcknowledgedBranches } from '~/helpers/branch';
import { getDomainByBranch } from '~/helpers/domain';
import { buildUrl } from '~/helpers/routing';
import type { Language } from '~/types';

const LANGS: Record<Language, string> = {
  en: 'English',
  sv: 'Svenska',
  ru: 'Русский',
  he: 'עברית'
};

const branch = useBranch();
const branches = getAcknowledgedBranches(branch);
const { shortenCountry } = useFormat();
</script>

<style scoped>
.lang {
  padding-inline-end: var(--space-1);
  font-weight: 500;
}
.country {
  font-weight: 400;
  color: darkgray;
}
:deep(.v-select__menu-icon) {
  margin-inline-start: unset;
}
:deep(.v-input__control) {
  border: 1px solid #fff;
  border-radius: var(--border-r-md);
  padding: 0 var(--space-3) var(--space-2);
}
:deep(.v-field__input) {
  padding: var(--space-2) 0 0 0;
}

@media (max-width: 850px) {
  :deep(.v-field__input) {
    padding-inline-end: var(--space-2);
    width: 100vw;
  }
}
</style>